module.exports = __webpack_public_path__ + "media/question1_en.ddfc5fba.mp3";